import _Slider from './Slider';

import './style/index.js';

export type { SliderProps } from './Slider';
export * from './type';

export const Slider = _Slider;
export default Slider;
